import script from "./LangSelect.vue?vue&type=script&setup=true&lang=js"
export * from "./LangSelect.vue?vue&type=script&setup=true&lang=js"

import "./LangSelect.vue?vue&type=style&index=0&id=9c0a7eee&lang=scss&scoped=true"

import exportComponent from "E:\\项目\\弗莱德\\DL-Flight.Protal\\DL-Flight.Protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9c0a7eee"]])

export default __exports__